import { createFileRoute, Link } from "@tanstack/react-router";
import { useServerFn } from "@tanstack/react-start";
import { useQuery } from "@tanstack/react-query";
import { ArrowLeft } from "lucide-react";
import { AdminGate } from "@/components/admin/AdminGate";
import { getBlackDashboard } from "@/lib/black2x1/dashboard.functions";
import { LeadsTable } from "@/components/black2x1/BlackLeadsTable";

export const Route = createFileRoute("/admin/black-leads")({
  head: () => ({
    meta: [
      { title: "Admin · Leads BLACK 2026" },
      { name: "description", content: "Tabela completa de leads da BLACK 2026." },
      { property: "og:title", content: "Admin · Leads BLACK 2026" },
      { property: "og:description", content: "Tabela completa de leads da BLACK 2026." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
      { name: "robots", content: "noindex,nofollow" },
    ],
  }),
  component: () => <AdminGate route="/admin/black-dashboard"><BlackLeads /></AdminGate>,
});

function BlackLeads() {
  const fn = useServerFn(getBlackDashboard);
  const q = useQuery({ queryKey: ["black-dashboard", "", ""], queryFn: () => fn({ data: {} }), refetchInterval: 60_000 });
  return (
    <main className="black2x1-scope min-h-screen bg-black-campaign px-4 py-8 text-foreground">
      <div className="mx-auto max-w-7xl space-y-6">
        <Link to="/admin/black-dashboard" className="inline-flex items-center gap-1 text-sm text-muted-foreground hover:text-foreground"><ArrowLeft className="h-4 w-4" /> Dashboard da Black</Link>
        <h1 className="text-3xl font-bold"><span className="text-black-campaign-lilac">LEADS</span> BLACK 2026</h1>
        {q.data ? <LeadsTable rows={q.data.tabela} onDeleted={() => q.refetch()} completa /> : <p className="text-sm text-muted-foreground">{q.error ? (q.error as Error).message : "Carregando leads…"}</p>}
      </div>
    </main>
  );
}
